import { Outlet, Navigate } from "react-router-dom";
import { useAuthContext } from "../providers/AuthProvider";
import { Box } from "@mui/material";

const PrivateRoutes = () => {
  const { isAuthenticated } = useAuthContext();
  return isAuthenticated ? (
    <Box>
      <Outlet />
    </Box>
  ) : (
    <Navigate to="/" />
  );
};
export default PrivateRoutes;
